import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { SenatRegistration } from "./hooks/useSenatData";

interface SenatTableProps {
  registrations: SenatRegistration[];
}

const formatDate = (d: string | null | undefined) => {
  if (!d) return "-";
  try {
    return format(new Date(d), "dd/MM/yyyy", { locale: fr });
  } catch {
    return d as string;
  }
};

export const SenatTable = ({ registrations }: SenatTableProps) => {
  return (
    <div className="rounded-md border overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nom</TableHead>
            <TableHead>Prénom</TableHead>
            <TableHead>Date de naissance</TableHead>
            <TableHead>Lieu de naissance</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Téléphone</TableHead>
            <TableHead className="text-right">Montant</TableHead>
            <TableHead>Statut paiement</TableHead>
            <TableHead>Date d'inscription</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {registrations.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.last_name}</TableCell>
              <TableCell>{r.first_name}</TableCell>
              <TableCell>{formatDate(r.birth_date)}</TableCell>
              <TableCell>{r.birth_place}</TableCell>
              <TableCell>{r.email || "-"}</TableCell>
              <TableCell>{r.phone || "-"}</TableCell>
              <TableCell className="text-right">{r.amount ? `${r.amount} €` : "-"}</TableCell>
              <TableCell>{r.payment_status}</TableCell>
              <TableCell>{formatDate(r.created_at)}</TableCell>
            </TableRow>
          ))}
          {registrations.length === 0 && (
            <TableRow>
              <TableCell colSpan={9} className="text-center text-muted-foreground py-6">
                Aucune inscription
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
